import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

interface TourIncludedItemProps {
    title: string,
    displayIcon?: boolean
}

const TourIncludedItem: React.FC<TourIncludedItemProps> = ({ title, displayIcon = true }) => {
    return (
        <Box mt={0.9} display={"flex"} flexDirection={"row"} alignItems={"center"}>
            {displayIcon && (
                <Box
                    width={24}
                    height={24}
                    mr={1}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    borderRadius={"50%"}
                    sx={{
                        backgroundColor: "rgba(223, 92, 45, 0.14)",
                        color: "primary.light"
                    }}>
                    <CheckRoundedIcon sx={{ fontSize: 18 }} />
                </Box>
            )}
            <Typography
                variant='subtitle2'
                color={"text.primary"}
                fontWeight={600}>
                {title}
            </Typography>
        </Box>
    )
}

export default TourIncludedItem;